import React from 'react';
import { FormattedMessage } from 'react-intl';

const PasswordFailedNotificationContent = () => {
    return (
        <FormattedMessage
          id="ids_passwordError"
          description="password error message"
          defaultMessage="Le mot de passe est incorrect."
        />
    );
}

export default PasswordFailedNotificationContent;